import { reactive } from "vue";

export const chatroomStore = reactive({
    messages: [],
    message: {},
    chatLabels: {},
    chatRoom: {},
    activeChatContact: {},
});

export const resetChatRoomStore = () => {
    chatroomStore.activeChatContact = {};
    chatroomStore.chatRoom = {};
};

// [info]: i do not think this state is required anymore.
// export const messageStatus = reactive({
//     isSend: false,
// });

export const sendEmailNotification = reactive({
    isSend: false,
});

export const chatroomStatus = reactive({
    status: "",
});

export const filterCriteriaList = reactive({
    filterCriteria: {},
});
